import Styles from './loading-spinner.module.scss';

type LoadingSpinnerProps = {
  width?: string;
  height?: string;
  size?: string;
};

export function LoadingSpinner({ width = '3.5rem', height = '3.5rem', size = '2' }: LoadingSpinnerProps) {
  return <span className={Styles.LoadingSpinner} style={{ width, height }} data-size={size}></span>;
}
